import React from 'react'
import Navbar from '../../components/Navbar/Navbar'
import SearchBox from '../../components/CustomWidgets/SearchBox';
import i18next from "i18next";
import { useTranslation } from 'react-i18next';
import Plus from "@mui/icons-material/Add";
import { useState, useCallback, useEffect, useRef } from 'react';
// import PromotionsNodataImage from '../../assets/Images/no-data-promotions.png';
import BackArrow from "@mui/icons-material/ArrowBackIosNew";
import { AutoComplete, Input } from 'antd'
import { debounce } from "@mui/material";
import { getInventoryallproducts } from "../../API  Functions/InventoryFunctions";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import dummy_image from "../../assets/Images/gallery.svg";
import deleteicon from "../../assets/Order/Delete.svg";
import axiosInstance from "../../AxiosInstance";
import { URLS } from '../../API/API endpoints';
import PromotionsTable from './PromotionsTable';
import { Select } from "antd";
import { Modal } from "antd"
import ShimmerLoader from "../../loading"
import {
    getGroupProducts,
    getProductGroups,
} from "../../API  Functions/productGroupFunctions";
import SelectBox from "../../components/CustomWidgets/SelectBox";
import { DatePicker } from "antd";
import dayjs from "dayjs"
import { useMemo } from "react";
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { order } from '@mui/system';
import { line } from 'framer-motion/client';
import { ConfigProvider } from "antd";
import enUS from "antd/locale/en_US";
import arEG from "antd/locale/ar_EG"; // adjust to whatever locale codes you actually support

dayjs.extend(isSameOrAfter);



const Promotions = () => {
    const { t, i18n } = useTranslation();
    const [promotions, setPromotions] = useState([]);
    const [showCreatePromotion, setShowCreatePromotion] = useState(false);
    const [activeTab, setActiveTab] = useState("product");
    const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedProductId, setSelectedProductId] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [Productoptions, setProductoptions] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [orderLines, setOrderLines] = useState([]);
    const [groupOrderLines, setGroupOrderLines] = useState([]);
    const [searching, setSearching] = useState(false);
    const [currentstep, setCurrentStep] = useState(1);
    const [selectedChannel, setSelectedChannel] = useState("pos");
    const [promotionType, setPromotionType] = useState("percentage")
    const [amount, setAmount] = useState(0);
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [promotionOn, setPromotionOn] = useState("")
    const antdLocale = i18n.language === "ar" ? arEG : enUS;
    const [currentLimit, setCurrentLimit] = useState(10); // Default limit
    const [currentOffset, setCurrentOffset] = useState(0); // Default Offset
    const [originalPromotions, setOriginalPromotions] = useState([])
    const [selectedPromotion, setSelectedPromotion] = useState(null)
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selectedBrands, setSelectedBrands] = useState([])
    const [loading, setloading] = useState(false)
    // Loading state for the bulk discount list (initial / refetch) and for the
    // edit drawer while promotion details are being fetched.
    const [pageLoading, setPageLoading] = useState(true)
    const [drawerLoading, setDrawerLoading] = useState(false)
    const [showConfirmModal, setShowConfirmModal] = useState(false)
    const [productGroups, setProductGroups] = useState([])
    const [groups, setGroups] = useState([])
    const [selectedBrandIds, setSelectedBrandIds] = useState([])
    const [brandSearchQuery, setBrandSearchQuery] = useState("")
    const [brandOptions, setBrandOptions] = useState([])
    const [showBrandDropdown, setShowBrandDropdown] = useState(false)
    const [initialLoad, setInitialLoad] = useState(true); // add this state

    const drawerRef = useRef(null)

    const activeLines = activeTab === "product" ? orderLines : groupOrderLines;

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (drawerRef.current && !drawerRef.current.contains(event.target)) {
                setShowCreatePromotion(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const validationState = useMemo(() => {
        return activeLines.map((product) => {
            const salePrice =
                product.sale_price ??
                product.current_price ??
                product.original_price ??
                0;

            const costPrice =
                product.cost_price ??
                product.discounted_price ??
                0;

            const maxDiscount = salePrice - costPrice;


            if (maxDiscount <= 0) return true;

            if (promotionType === "fixed") {
                return Number(amount) <= maxDiscount;
            }

            return salePrice * (Number(amount) / 100) <= maxDiscount;
        });
    }, [activeLines, amount, promotionType]);

    const isStepInvalid = useMemo(() => {
        const amt = Number(amount);
        const hasDates = startDate && endDate;
        const datesValid = hasDates && dayjs(endDate).isSameOrAfter(dayjs(startDate));
        const prt = promotionType;

        const promoFieldsInvalid =
            Number.isNaN(amt) ||
            amt <= 0 ||
            (prt === "percentage" && amt > 100) ||
            !hasDates ||
            !datesValid;

        if (activeTab === "product") return orderLines.length === 0 || promoFieldsInvalid;
        if (activeTab === "groups") return groupOrderLines.length === 0 || promoFieldsInvalid;
        return true;
    }, [
        activeTab,
        orderLines.length,
        groupOrderLines.length, // ✅ replace selectedBrandIds.length

        promotionType,
        amount,
        startDate,
        endDate,
    ]);
    const categories = [
        "All",
        "Bakery",
        "Fruits",
        "Household essentials",
        "Vegetables",
        "Personal Care",
        "Dental Care",
        "Feminine Hygiene",
        "Beauty & Cosmetics",
        "Hair Care",
        "Quick Bites",
        "Skincare",
    ];
    const brands = [
        "Abu Auf",
        "Nescafe",
        "Juhayna",
        "Johnsons",
        "Maggie"
    ]

    useEffect(() => {
        if (groups.length > 0) {
            setBrandOptions(groups);
        }
    }, [groups]);

    useEffect(() => {
        getAllPromotions();
    }, [currentLimit, currentOffset]);
    const userData = useSelector((state) => state?.login?.user?.result);

    // Both fetched (edit) lines and newly-searched lines can use different id
    // keys (`product_id` vs `prod_id`), so always resolve to a single id when
    // deleting/keying a line. Guard against an undefined/null id so a missing
    // identifier never wipes out the whole list.
    const getLineId = (line) => line?.prod_id ?? line?.product_id;

    const handleDeleteLine = (id) => {
        if (id === undefined || id === null) return;
        console.log(id)
        if (activeTab === "product") {
            setOrderLines((prev) => prev.filter((line) => getLineId(line) !== id));
        } else {
            setGroupOrderLines((prev) => prev.filter((line) => getLineId(line) !== id));
            console.log(groupOrderLines)
        }
    };

    const handleBrandSelect = async (groupId) => {
        const alreadySelected = selectedBrandIds.includes(groupId);
        if (alreadySelected) {
            setSelectedBrandIds((prev) => prev.filter((id) => id !== groupId));
            const remainingIds = selectedBrandIds.filter((id) => id !== groupId);
            if (remainingIds.length === 0) {
                setGroupOrderLines([]);
            } else {
                try {
                    const allProducts = [];
                    for (const id of remainingIds) {
                        const res = await axiosInstance.post(URLS.GET_GROUP_PRODUCT, { company_id: company_id, user_id: user_id, group_id: id });
                        const products = res?.data?.result[0].product_list || [];
                        allProducts.push(...products);
                    }
                    const seen = new Set();
                    const deduped = allProducts.filter((p) => {
                        const key = p.prod_id ?? p.product_id;
                        if (seen.has(key)) return false;
                        seen.add(key);
                        return true;
                    });
                    setGroupOrderLines(deduped);
                } catch (error) {
                    console.error("Error re-fetching group products:", error);
                }
            }
        } else {
            setSelectedBrandIds((prev) => [...prev, groupId]);
            try {
                const res = await axiosInstance.post(URLS.GET_GROUP_PRODUCT, { company_id: company_id, user_id: user_id, group_id: groupId });
                const products = res?.data?.result[0]?.product_list || [];
                setGroupOrderLines((prev) => {
                    const seen = new Set(prev.map((p) => p.prod_id ?? p.product_id));
                    const newProducts = products.filter((p) => {
                        const key = p.prod_id ?? p.product_id;
                        if (seen.has(key)) return false;
                        seen.add(key);
                        return true;
                    });
                    return [...prev, ...newProducts];
                });
            } catch (error) {
                console.error("Error fetching group products:", error);
                toast.error("Failed to fetch products for this group.");
            }
        }
    };

    const GetGroups = async (text = "") => {
        const payload = {
            lang: i18n.language === "ar" ? "ar_001" : "en_US",
            search: text,
            company_id: company_id,
            user_id: user_id,
            offset: currentOffset,
            limit: currentLimit,
        };
        try {
            const res1 = await getProductGroups(payload);
            console.log(res1)
            if (res1?.result[0]?.status_code === 200) {
                const fetchedGroups = res1?.result[0]?.product_groups || [];
                // Hide groups that have no products in them so they can't be
                // picked when creating/editing a bulk discount.
                setGroups(fetchedGroups.filter((g) => Number(g?.no_of_products) > 0));
            } else {
                setGroups([]);
            }
        } catch (error) {
            console.error("Error fetching KPI data:", error);
            setloading(false);
        } finally {
            setloading(false);
        }
    };

    useEffect(() => {
        GetGroups()
    }, [])

    const searchBrands = useCallback(
        debounce((value) => {
            if (!value || value.length < 1) {
                setBrandOptions(groups);
            } else {
                setBrandOptions(
                    groups.filter((g) =>
                        g.name?.toLowerCase().includes(value.toLowerCase()) ||
                        g.name_ar?.toLowerCase().includes(value.toLowerCase())
                    )
                );
            }
        }, 300),
        [groups],
    );

    const debouncedSearch = debounce((value) => {
        promotions.filter((promotion) => promotion.promotion_type.includes(value))
    }, 1000);


    const company_id = useSelector(
        (state) => state?.login?.user?.result?.company_id,
    );

    const handleRowClick = async (promotion) => {
        setSelectedPromotion(promotion);
        setOrderLines([]);
        setGroupOrderLines([]);
        setCurrentStep(1);
        setShowCreatePromotion(true)
        setDrawerLoading(true)

        const payload = { promotion_id: promotion.id };

        try {
            const res = await axiosInstance.post(URLS.GET_PROMOTION_DETAILS, payload);
            console.log(res)
            const data = res?.data?.result?.data;
            console.log(data.promotion_type)

            setPromotionType(data.promotion_type || "");
            setAmount(data.value || 0);
            setStartDate(data.start_date || "");
            setEndDate(data.end_date || "");
            setSelectedChannel(data.promotion_on || "");
            console.log(data.apply_on)
            if (data.apply_on === "groups") {
                setActiveTab("groups");
                setGroupOrderLines(data.products || []);
                setSelectedBrands(data.group_ids || selectedBrands); // ✅ restore for edit


            } else {
                setActiveTab("product");
                setOrderLines(data.products || []);
                console.log(orderLines)
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to fetch promotion details.");
        } finally {
            setDrawerLoading(false)
        }
    };

    const confirmDelete = (promotion) => {
        console.log("request reached on confirm delete")
        setSelectedPromotion(promotion)
        setShowConfirmModal(true)
    }

    const handlePromotionUpdate = async (promotion) => {
        try {
            const payload = {
                id: selectedPromotion.id,
                start_date: startDate,
                end_date: endDate,
                promotion_type: promotionType,
                value: parseFloat(amount) || 0,
                promotion_on: 'pos',
                apply_on: activeTab,
                ...(activeTab === "product"
                    ? { product_ids: orderLines.map((line) => line.prod_id ?? line.product_id) }
                    : {
                        group_ids: selectedBrandIds,
                        product_ids: groupOrderLines.map((line) => line.prod_id ?? line.product_id)
                    }
                ),
            };

            const res = await axiosInstance.post(URLS.UPDATE_PROMOTIONS, payload)
            const result = res?.data?.result
            if (result?.status_code === 200) {
                toast.success(
                    activeTab === "product"
                        ? t("Product promotion updated successfully")
                        : t("Group promotion updated successfully")
                );
                setShowCreatePromotion(false);
                setSelectedPromotion(null); // use null instead of false for consistency
                await getAllPromotions();
            } else {
                toast.error(result?.status || t("Failed to update promotion"));
            }
        }
        catch (error) {
            console.log(error)
            toast.error(t("Failed to update bulk discount"));
        }
    }

    const handleDeletePromotion = async (promotion) => {
        try {
            setloading(true)
            const payload = {
                promotion_id: promotion.id
            }
            const res = await axiosInstance.post(URLS.DELETE_PROMOTIONS, payload)
            console.log(res?.data)

            if (res?.data?.result?.status_code === 200) {
                toast.success(t("Bulk Discount removed successfully"));
                await getAllPromotions();
                setShowConfirmModal(false);
                setloading(false)
            } else {
                toast.error(res?.status || "Failed to remove products from group");
            }
        }
        catch (error) {
            console.log(error)
            toast.error(t("Failed to remove products from group"));
        }
    }

    const handleProductSelect = (value) => {
        const selectedProduct = Productoptions.find(
            (product) => product.product_name === value,
        );
        console.log(selectedProduct)
        if (!selectedProduct) return;

        const isDuplicate = orderLines.some(
            (product) => product.prod_id === selectedProduct.quant_id || product.production_id === selectedProduct.quant_id,
        );

        if (isDuplicate) {
            toast.error(`${selectedProduct.product_name} is already in the list.`);
            return;
        }

        const mappedProduct = {
            barcode: selectedProduct.barcode,
            machine_barcode: selectedProduct.machine_barcode,
            weight: 0,
            prod_id: selectedProduct.quant_id,
            name:
                selectedProduct.product_name2 && selectedProduct.product_name2 != ""
                    ? selectedProduct.product_name2
                    : selectedProduct.product_name,
            cost_price: selectedProduct.current_cost_price,
            sale_price: selectedProduct.current_price,
            qty_available: selectedProduct.system_quantity,
            forecasted_qty: selectedProduct.system_quantity,
            image_url: selectedProduct.product_image_url,
            is_loose: false,
            uom: selectedProduct.uom,
            product_type: "sp",
            is_favorite: false,
            product_main_categ: selectedProduct.categ_id,
            discount_master_id: false,
            discount_qty: selectedProduct.prod_discount ?? 0,
            discount_type: false,
            product_selling_units: [],
            is_package: false,
        };

        setOrderLines((prev) => [...prev, mappedProduct]);
    };

    function showCreatePromotionModal() {
        setSelectedPromotion(null);
        setPromotionType("percentage");
        setOrderLines([]);
        setGroupOrderLines([]);
        setSelectedBrandIds([]);        // ✅ add this
        setBrandSearchQuery("");
        setBrandOptions(groups);         // ✅ add this — reset to full list not stale selection
        setAmount(0);
        setStartDate("");
        setEndDate("");
        setSelectedChannel("");
        setActiveTab("product");
        setCurrentStep(1);
        setSearchQuery("");
        setShowDropdown(false);
        setShowBrandDropdown(false);
        setProductoptions([]);
        setShowCreatePromotion(true);
    }


    const searchResult = useCallback(
        debounce(async (value) => {
            setSearching(true);
            try {
                const response = await getInventoryallproducts(
                    user_id,
                    company_id,
                    false,
                    false,
                    value,
                    10,
                    0,
                );
                console.log("response==>", response);

                if (response?.result[0]?.response) {
                    setProductoptions(response.result[0].response);
                } else {
                    setProductoptions([]);
                }
            } catch (error) {
                console.error(error);
                setProductoptions([]);
            } finally {
                setSearching(false);
            }
        }, 1000),
        [user_id, company_id],
    );

    const handlePromotionCreate = async () => {
        try {
            const payload = {
                company_id: company_id,
                start_date: startDate,
                end_date: endDate,
                promotion_type: promotionType,
                value: parseFloat(amount) || 0,
                apply_on: activeTab,
                promotion_on: 'pos',
                ...(activeTab === "product"
                    ? { product_ids: orderLines.map((line) => line.prod_id) }
                    : {
                        group_ids: selectedBrandIds,
                        product_ids: groupOrderLines.map((line) => line.prod_id ?? line.product_id)  // ✅ send remaining products after deletion
                    }
                ),
            };

            const response = await axiosInstance.post(URLS.CREATE_PROMOTION, payload);

            console.log(response)
            if (response?.data) {
                toast.success("Bulk Discount created successfully!");
                setShowCreatePromotion(false);
                setSelectedPromotion(null);
                setSearchQuery("");
                setOrderLines([]);
                setGroupOrderLines([]);
                setPromotionType("");
                console.log("Selected Brand Ids ", selectedBrandIds)
                setSelectedBrands(selectedBrandIds)
                setSelectedBrandIds([])
                setAmount(0);
                setStartDate("");
                setEndDate("");
                setSelectedChannel("");
                setCurrentStep(1);
                await getAllPromotions();
            }
        } catch (error) {
            toast.error("Failed to create promotion. Please try again.");
            console.error(error);
        }
    };

    const handlePagination = useCallback((values) => {
        setCurrentLimit(values.limit);
        setCurrentOffset(values.offset);
    }, []);

    const handleSearch = useCallback(
        debounce((value) => {
            if (!value || value.trim() === "") {
                setPromotions(originalPromotions);
            } else {
                const filtered = originalPromotions.filter((promotion) =>
                    promotion.promotion_type?.toLowerCase().includes(value.toLowerCase())
                );
                setPromotions(filtered);
            }
        }, 500),
        [originalPromotions],
    );

    const getAllPromotions = async () => {
        setPageLoading(true);
        console.log("getAllPromotions called with:", { currentLimit, currentOffset });

        try {
            const payload = {
                company_id: company_id,
                limit: currentLimit,
                offset: currentOffset
            };

            const response = await axiosInstance.post(URLS.GET_PROMOTIONS, payload);
            console.log(response?.data?.result?.data)
            if (response?.data) {
                setPromotions(response?.data?.result?.data);
                setOriginalPromotions(response?.data?.result?.data);
            }
        } catch (error) {
            toast.error("Failed to fetch bulk discounts.");
            console.error(error);
        } finally {
            setPageLoading(false);
            setInitialLoad(false); // ✅ only false after first fetch

        }
    };

    const options = [
        {
            value: "percentage",
            label: `${t("Percentage")}`
        },
        {
            value: "fixed",
            label: `${t("Fixed")}`
        }
    ]

    // Small shimmer block reused for both the list skeleton and the drawer skeleton.
    const ShimmerBlock = ({ className = "" }) => (
        <div className={`animate-pulse rounded-lg bg-gray-200 ${className}`} />
    );

    const allProductsValid = useMemo(() => {
        return validationState.every(Boolean);
    }, [validationState]);

    return (
        <>
            <div className="flex w-full flex-col overflow-y-auto bg-[#F6F7F9] pb-2 md:h-full">
                <Navbar heading={t("Bulk Discount")} />
                <div className="custom-scrollbar ms-1 mt-2 flex-grow overflow-y-auto overflow-hidden sm:ms-3">
                    <div className="font-extrabold mb-3"></div>
                    <div className="mt-3">
                        <div className="flex justify-between mt-3 me-8">
                            <div className='w-8'></div>
                            <button
                                className="flex h-10 w-full items-center justify-center  rounded-lg bg-primaryBlue text-sm font-semibold text-white sm:w-48"
                                onClick={() => {
                                    showCreatePromotionModal();
                                }}
                            >
                                <Plus style={{ fontSize: "1.5em", MozMarginStart: -10 }} />
                                <span>{t("Create Bulk Discount")}</span>
                            </button>
                        </div>


                        {initialLoad ? (
                            <ShimmerLoader />
                        ) : !promotions.length ? (
                            <div className="flex h-[60vh] w-full flex-col items-center justify-center gap-4">
                                <h1 className="font-semibold" style={{ fontSize: "27px" }}>{t("No Bulk Discount Yet!")}</h1>
                                <p className="text-[#64748B]">{t("Start one now to bring more customers to your store!")}</p>
                            </div>
                        ) : (
                            <>
                                <PromotionsTable additionalData={promotions}
                                    showEdit={!userData?.is_sub_store && !userData?.is_warehouse}
                                    pagination={handlePagination}
                                    onRowClick={handleRowClick}
                                    onDelete={confirmDelete}
                                    onEditLine={handleRowClick}
                                />
                            </>
                        )}
                    </div>
                </div>
                {showCreatePromotion && (
                    <div
                        onMouseDown={() => {
                            setShowCreatePromotion(false);
                            setSelectedBrandIds([]);
                            setSelectedBrands([]);
                        }}
                        className="fixed inset-0 z-40 bg-black bg-opacity-50"
                    >
                        {/* Drawer */}
                        <div
                            className={`fixed top-0 right-0 z-50 h-screen w-[500px] bg-white shadow-lg
                transform transition-transform duration-300 flex flex-col
                ${showCreatePromotion ? "translate-x-0" : "translate-x-full"}`

                            }
                            onMouseDown={(e) => e.stopPropagation()} // ✅ stops backdrop from firing

                        >
                            {/* ── FIXED HEADER ── */}
                            <div className="flex-shrink-0 px-6 pt-6 pb-4 border-b border-gray-200">

                                {/* Row 1: Back arrow + Title + Save button */}
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-2">
                                        <BackArrow
                                            style={{ fontSize: "1.5em", cursor: "pointer", width: "25px", height: "15px", marginTop: "2px" }}
                                            onClick={() => {
                                                setShowCreatePromotion(false)
                                                setSelectedBrandIds([]);

                                            }}
                                        />

                                        <div className="flex flex-col">
                                            <span className="text-md font-bold">
                                                {selectedPromotion
                                                    ? t("Edit Bulk Discount")
                                                    : t("Create Bulk Discount")}
                                            </span>

                                            {selectedPromotion && (
                                                <span className="text-xs text-gray-500">
                                                    {t("Promotion ID")}: #{selectedPromotion.id}
                                                </span>
                                            )}
                                        </div>
                                    </div>

                                    <button
                                        disabled={
                                            isStepInvalid ||
                                            drawerLoading ||
                                            validationState.some((isValid) => !isValid)
                                        }
                                        onClick={() => {
                                            selectedPromotion
                                                ? handlePromotionUpdate()
                                                : handlePromotionCreate();
                                        }}
                                        className="px-5 py-1.5 text-sm font-semibold border rounded-lg transition-colors disabled:opacity-50 bg-primaryBlue text-white hover:opacity-90 border-primaryBlue"
                                    >
                                        {t("Save")}
                                    </button>
                                </div>

                                {/* Tabs */}
                                {!selectedPromotion && <ul className="flex mt-4 border-b border-gray-300 list-none justify-around items-center"
                                    style={{ fontSize: "13px" }}>
                                    <li
                                        onClick={() => { setActiveTab("product"); }}
                                        className={`cursor-pointer pb-2 border-b-2 ${activeTab === "product"
                                            ? "border-sky-500 text-[#343C6A] font-semibold"
                                            : "border-transparent text-[#5B75A1]"}`}
                                    >
                                        {t("Product")}
                                    </li>
                                    <li
                                        onClick={() => { setActiveTab("groups"); }}
                                        className={`cursor-pointer pb-2 border-b-2 ${activeTab === "groups"
                                            ? "border-sky-500 text-[#343C6A] font-semibold"
                                            : "border-transparent text-[#5B75A1]"}`}
                                    >
                                        {t("Product Groups")}
                                    </li>
                                </ul>}
                            </div>

                            {/* ── SCROLLABLE BODY ── */}
                            <div className="flex-1 overflow-y-auto px-6 py-4">
                                {drawerLoading ? (
                                    <div className="space-y-5">
                                        <ShimmerLoader className="h-11 w-full" />
                                        <div className="flex gap-4">
                                            <ShimmerLoader className="h-10 flex-1" />
                                            <ShimmerLoader className="h-10 flex-1" />
                                        </div>
                                        <div className="flex gap-4">
                                            <ShimmerLoader className="h-10 flex-1" />
                                            <ShimmerLoader className="h-10 flex-1" />
                                        </div>
                                        <ShimmerLoader className="h-12 w-full" />
                                        {[...Array(4)].map((_, i) => (
                                            <ShimmerLoader key={i} className="h-14 w-full" />
                                        ))}
                                    </div>
                                ) : (
                                    <>
                                        {/* Product tab */}
                                        {activeTab === "product" && (
                                            <>
                                                {/* Search */}
                                                <div className="relative w-full mb-4">
                                                    <AutoComplete
                                                        value={searchQuery}
                                                        style={{ width: "100%", height: "43px" }}
                                                        open={showDropdown}
                                                        onDropdownVisibleChange={(open) => setShowDropdown(open)}
                                                        options={Productoptions.map((prod) => ({
                                                            value: prod.product_name,
                                                            label: (
                                                                <div className="flex justify-between items-center">
                                                                    <span>
                                                                        {prod.product_name2 && prod.product_name2 !== ""
                                                                            ? prod.product_name2
                                                                            : prod.product_name}
                                                                    </span>
                                                                    {/* ✅ check both prod_id and product_id */}
                                                                    {orderLines.some((p) =>
                                                                        (p.prod_id ?? p.product_id) === prod.quant_id
                                                                    ) && (
                                                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                                                                                stroke="#16A34A" strokeWidth="3"
                                                                                strokeLinecap="round" strokeLinejoin="round">
                                                                                <polyline points="20 6 9 17 4 12" />
                                                                            </svg>
                                                                        )}
                                                                </div>
                                                            ),
                                                            disabled: orderLines.some((p) =>
                                                                (p.prod_id ?? p.product_id) === prod.quant_id
                                                            ),
                                                        }))}
                                                        filterOption={false}
                                                        onSearch={(val) => {
                                                            setSearchQuery(val);
                                                            if (val.length >= 2) {
                                                                searchResult(val);
                                                                setShowDropdown(true);
                                                            } else {
                                                                setProductoptions([]);
                                                                setShowDropdown(false);
                                                            }
                                                        }}
                                                        onSelect={(val) => {
                                                            console.log(val)
                                                            handleProductSelect(val);
                                                            // Clear the last search term/options once a product is
                                                            // added so stale text doesn't linger in the field.
                                                            setSearchQuery("")
                                                            setProductoptions([])
                                                        }}
                                                    >
                                                        <Input
                                                            placeholder={t("search_product")}
                                                            size="large"
                                                            style={{ borderColor: "#d9d9d9", boxShadow: "none" }}
                                                            suffix={
                                                                searchQuery ? (
                                                                    <CloseOutlined
                                                                        onClick={() => { setShowDropdown(false); setSearchQuery(""); setProductoptions([]) }}
                                                                        style={{ cursor: "pointer" }}
                                                                    />
                                                                ) : (
                                                                    <SearchOutlined />
                                                                )
                                                            }
                                                        />
                                                    </AutoComplete>
                                                </div>

                                                {/* Promo rule fields */}
                                                <div className="space-y-5 text-[12px] mb-4">
                                                    <div className="flex gap-4">
                                                        <div className="flex-1">
                                                            <label className="mb-2 block text-[12px] font-medium text-gray-700">
                                                                {t("Bulk Discount Type")}
                                                            </label>
                                                            <SelectBox
                                                                placeholder="Select Bulk discount Type"
                                                                name="filter"
                                                                onChange={(e) => setPromotionType(e.target.value)}
                                                                options={options}
                                                                value={promotionType}
                                                            />
                                                        </div>

                                                        <div className="flex-1">
                                                            <label className="mb-2 block text-[12px] font-medium text-gray-700">
                                                                {t("Amount")}
                                                            </label>
                                                            <input
                                                                type="number"
                                                                placeholder={t("Enter Amount")}
                                                                className="h-[40px] w-full rounded-lg border border-gray-300 px-3 outline-none focus:border-primaryBlue"
                                                                onChange={(e) => setAmount(e.target.value)}
                                                                value={amount}
                                                            />
                                                            {promotionType === "percentage" && Number(amount) > 100 && (
                                                                <p className="text-red-500 text-[12px]">
                                                                    Percentage cannot be greater than 100
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="flex gap-4">
                                                        <div className="flex-1">
                                                            <label className="mb-2 block text-[12px] font-medium text-gray-700">
                                                                {t("Start Date")}
                                                            </label>
                                                            <ConfigProvider locale={antdLocale}>
                                                                <DatePicker
                                                                    className="w-full h-[40px]"
                                                                    showTime={{ format: "HH:mm" }}
                                                                    format="YYYY-MM-DD HH:mm"
                                                                    placeholder={t("Select Date")}
                                                                    value={startDate ? dayjs(startDate) : null}
                                                                    onChange={(date) =>
                                                                        setStartDate(date ? date.format("YYYY-MM-DD HH:mm:[00]") : "")
                                                                    }
                                                                    disabledDate={(current) =>
                                                                        current && current < dayjs().startOf("day")
                                                                    }
                                                                />
                                                            </ConfigProvider>
                                                        </div>

                                                        <div className="flex-1">
                                                            <label className="mb-2 block text-[12px] font-medium text-gray-700">
                                                                {t("End Date")}
                                                            </label>
                                                            <ConfigProvider locale={antdLocale}>
                                                                <DatePicker
                                                                    className="w-full h-[40px]"
                                                                    showTime={{ format: "HH:mm" }}
                                                                    format="YYYY-MM-DD HH:mm"
                                                                    placeholder={t("Select Date")}
                                                                    value={endDate ? dayjs(endDate) : null}
                                                                    onChange={(date) =>
                                                                        setEndDate(date ? date.format("YYYY-MM-DD HH:mm:[00]") : "")
                                                                    }
                                                                    disabledDate={(current) =>
                                                                        current &&
                                                                        current < (startDate ? dayjs(startDate).startOf("day") : dayjs().startOf("day"))
                                                                    }
                                                                />
                                                                </ConfigProvider>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Added Products badge */}
                                                <div className="flex items-center justify-between rounded-lg bg-[#F1F2F666] px-4 py-3 mb-4">
                                                    <div className="flex items-center gap-2">
                                                        <div className="h-2 w-2 rounded-full bg-primaryBlue"></div>
                                                        <span className="text-sm font-semibold tracking-wide text-[#343C6A]">
                                                            {t("Added Products")}
                                                        </span>
                                                    </div>
                                                    <span>{orderLines.length}</span>
                                                </div>

                                                {/* Product list */}

                                                <div className="space-y-2">
                                                    {selectedPromotion && activeTab === "product" && orderLines.map((line, index) => (

                                                        <div key={getLineId(line) ?? index}
                                                            className={`flex justify-between items-center rounded-lg bg-white p-2 shadow-sm "}`

                                                            }
                                                            style={{
                                                                backgroundColor: validationState[index] ? "#ffffff" : "#fef2f2",
                                                                border: validationState[index] ? "1px solid #e5e7eb" : "1px solid #f87171"
                                                            }}
                                                        >
                                                            <img
                                                                src={line.image_url || line.product_image_url || dummy_image}
                                                                alt={line.name || line.product_name}
                                                                className="w-10 h-10 object-contain rounded flex-shrink-0"
                                                            />
                                                            <div className="flex flex-1 flex-col mx-2">
                                                                <p className="text-[12px] font-semibold text-gray-800 leading-tight">
                                                                    {line.name || line.product_name}
                                                                </p>
                                                                <p className="text-xs text-gray-600">{line.barcode}</p>

                                                                {!validationState[index] && (
                                                                    <p className="text-xs text-red-600 mt-1">
                                                                        Max Discount: {line.original_price - line.discounted_price || line.sale_price - line.cost_price}
                                                                    </p>
                                                                )}
                                                            </div>
                                                            <p className="font-normal whitespace-nowrap text-right mr-3 text-[12px]">

                                                                EGP {line.original_price ? line.original_price.toFixed(2) : line?.sale_price.toFixed(2)}
                                                            </p>
                                                            {!userData?.is_sub_store && !userData?.is_warehouse && (
                                                                <button
                                                                    onClick={() => handleDeleteLine(getLineId(line))}
                                                                    className="flex h-9 w-9 items-center justify-center rounded-full bg-red-50 hover:bg-red-100"
                                                                >
                                                                    <img src={deleteicon} alt="Delete" className="h-4 w-4" />
                                                                </button>
                                                            )}
                                                        </div>
                                                    ))}
                                                    {selectedPromotion && activeTab === "groups" && groupOrderLines.map((line, index) => (

                                                        <div key={getLineId(line) ?? index}
                                                            className={`flex justify-between items-center rounded-lg bg-white p-2 shadow-sm "}`

                                                            }
                                                            style={{
                                                                backgroundColor: validationState[index] ? "#ffffff" : "#fef2f2",
                                                                border: validationState[index] ? "1px solid #e5e7eb" : "1px solid #f87171"
                                                            }}
                                                        >
                                                            <img
                                                                src={line.image_url || line.product_image_url || dummy_image}
                                                                alt={line.name || line.product_name}
                                                                className="w-10 h-10 object-contain rounded flex-shrink-0"
                                                            />
                                                            <div className="flex flex-1 flex-col mx-2">
                                                                <p className="text-[12px] font-semibold text-gray-800 leading-tight">
                                                                    {line.name || line.product_name}
                                                                </p>
                                                                <p className="text-xs text-gray-600">{line.barcode}</p>

                                                                {!validationState[index] && (
                                                                    <p className="text-xs text-red-600 mt-1">
                                                                        Max Discount: {line.original_price - line.discounted_price || line.sale_price - line.cost_price}
                                                                    </p>
                                                                )}
                                                            </div>
                                                            <p className="font-normal whitespace-nowrap text-right mr-3 text-[12px]">
                                                                EGP {line.original_price ? line.original_price.toFixed(2) : line.current_price}
                                                            </p>
                                                            {!userData?.is_sub_store && !userData?.is_warehouse && (
                                                                <button
                                                                    onClick={() => handleDeleteLine(getLineId(line))}
                                                                    className="flex h-9 w-9 items-center justify-center rounded-full bg-red-50 hover:bg-red-100"
                                                                >
                                                                    <img src={deleteicon} alt="Delete" className="h-4 w-4" />
                                                                </button>
                                                            )}
                                                        </div>
                                                    ))}

                                                    {!selectedPromotion && orderLines.map((line, index) => (
                                                        <div key={getLineId(line) ?? index}
                                                            style={{
                                                                backgroundColor: validationState[index] ? "#ffffff" : "#fef2f2",
                                                                border: validationState[index] ? "1px solid #e5e7eb" : "1px solid #f87171"
                                                            }}
                                                            className="flex justify-between items-center rounded-lg p-2 shadow-sm"
                                                        >
                                                            <img
                                                                src={line.image_url || dummy_image}
                                                                alt=""
                                                                className="w-10 h-10 object-contain rounded flex-shrink-0"
                                                            />
                                                            <div className="flex flex-col flex-1 mx-2">
                                                                <p className="font-semibold text-[12px] leading-tight">
                                                                    {line.name || line.product_name}
                                                                </p>
                                                                <p className="text-xs text-gray-600">{line.barcode}</p>

                                                                {!validationState[index] && (
                                                                    <p className="text-xs text-red-600 mt-1">
                                                                        Max Discount: {line.sale_price - line.cost_price}
                                                                    </p>
                                                                )}
                                                            </div>
                                                            <p className="font-normal whitespace-nowrap text-right mr-3 text-[12px]">
                                                                EGP {line.sale_price ? line.sale_price.toFixed(2) : line.current_price}
                                                            </p>
                                                            {!userData?.is_sub_store && !userData?.is_warehouse && (
                                                                <img
                                                                    src={deleteicon}
                                                                    className="cursor-pointer h-4 w-4 mx-2"
                                                                    alt="Delete"
                                                                    onClick={() => handleDeleteLine(getLineId(line))}
                                                                />
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            </>
                                        )}

                                        {/* Product Groups tab */}
                                        {activeTab === "groups" && (
                                            <>
                                                <AutoComplete
                                                    value={brandSearchQuery}
                                                    style={{ width: "100%", height: "43px" }}
                                                    open={showBrandDropdown}
                                                    onDropdownVisibleChange={(open) => setShowBrandDropdown(open)}
                                                    options={brandOptions.map((group) => ({
                                                        value: String(group.id),
                                                        label: (
                                                            <div className="flex justify-between items-center">
                                                                <div className="flex flex-col">
                                                                    <span className="text-sm font-semibold">{group.name}</span>
                                                                    <span className="text-xs text-gray-400">
                                                                        {group.no_of_products} products · {group.created_by}
                                                                    </span>
                                                                </div>
                                                                {/* ✅ check selectedBrandIds OR if any group product exists in groupOrderLines */}
                                                                {(selectedBrandIds.includes(group.id) ||
                                                                    (selectedPromotion && selectedBrands.includes(group.id))  // ✅ only check selectedBrands during edit
                                                                ) && (
                                                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                                                                            stroke="#16A34A" strokeWidth="3"
                                                                            strokeLinecap="round" strokeLinejoin="round">
                                                                            <polyline points="20 6 9 17 4 12" />
                                                                        </svg>
                                                                    )}
                                                            </div>
                                                        ),
                                                    }))}
                                                    filterOption={false}
                                                    onSearch={(val) => {
                                                        setBrandSearchQuery(val);
                                                        setBrandOptions(
                                                            val.length >= 1
                                                                ? groups.filter((g) =>
                                                                    g.name?.toLowerCase().includes(val.toLowerCase()) ||
                                                                    g.name_ar?.toLowerCase().includes(val.toLowerCase()))
                                                                : groups
                                                        );
                                                        setShowBrandDropdown(true);
                                                    }}
                                                    onSelect={(val) => {
                                                        handleBrandSelect(Number(val));
                                                        setBrandSearchQuery("");
                                                        setBrandOptions(groups);
                                                        setTimeout(() => setShowBrandDropdown(true), 0);
                                                    }}
                                                >
                                                    <Input
                                                        placeholder={t("Search Product Groups")}
                                                        size="large"
                                                        style={{ borderColor: "#d9d9d9", boxShadow: "none" }}
                                                        suffix={
                                                            brandSearchQuery ? (
                                                                <CloseOutlined
                                                                    onClick={() => { setBrandSearchQuery(""); setBrandOptions(groups); setShowBrandDropdown(true); }}
                                                                    style={{ cursor: "pointer" }}
                                                                />
                                                            ) : <SearchOutlined />
                                                        }
                                                    />
                                                </AutoComplete>

                                                {/* Promo rule fields */}
                                                <div className="space-y-5 text-[12px] mt-4 mb-4">
                                                    <div className="flex gap-4">
                                                        <div className="flex-1">
                                                            <label className="mb-2 block text-[12px] font-medium text-gray-700">
                                                                {t("Bulk Discount Type")}
                                                            </label>
                                                            <SelectBox
                                                                placeholder="Select Bulk Discount Type"
                                                                name="filter"
                                                                onChange={(e) => setPromotionType(e.target.value)}
                                                                options={options}
                                                                value={promotionType}
                                                            />
                                                        </div>

                                                        <div className="flex-1">
                                                            <label className="mb-2 block text-[12px] font-medium text-gray-700">
                                                                {t("Amount")}
                                                            </label>
                                                            <input
                                                                type="number"
                                                                placeholder={t("Enter Amount")}
                                                                className="h-[40px] w-full rounded-lg border border-gray-300 px-3 outline-none focus:border-primaryBlue"
                                                                onChange={(e) => setAmount(e.target.value)}
                                                                value={amount}
                                                            />
                                                            {promotionType === "percentage" && Number(amount) > 100 && (
                                                                <p className="text-red-500 text-[12px]">
                                                                    Percentage cannot be greater than 100
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="flex gap-4">
                                                        <div className="flex-1">
                                                            <label className="mb-2 block text-[12px] font-medium text-gray-700">
                                                                {t("Start Date")}
                                                            </label>
                                                            <DatePicker
                                                                className="w-full h-[40px]"
                                                                showTime={{ format: "HH:mm" }}
                                                                format="YYYY-MM-DD HH:mm"
                                                                value={startDate ? dayjs(startDate) : null}
                                                                onChange={(date) =>
                                                                    setStartDate(date ? date.format("YYYY-MM-DD HH:mm:[00]") : "")
                                                                }
                                                                disabledDate={(current) =>
                                                                    current && current < dayjs().startOf("day")
                                                                }
                                                            />
                                                        </div>

                                                        <div className="flex-1">
                                                            <label className="mb-2 block text-[12px] font-medium text-gray-700">
                                                                {t("End Date")}
                                                            </label>
                                                            <DatePicker
                                                                className="w-full h-[40px]"
                                                                showTime={{ format: "HH:mm" }}
                                                                format="YYYY-MM-DD HH:mm"
                                                                value={endDate ? dayjs(endDate) : null}
                                                                onChange={(date) =>
                                                                    setEndDate(date ? date.format("YYYY-MM-DD HH:mm:[00]") : "")
                                                                }
                                                                disabledDate={(current) =>
                                                                    current &&
                                                                    current < (startDate ? dayjs(startDate).startOf("day") : dayjs().startOf("day"))
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Added Products badge */}
                                                <div className="mb-3 flex items-center justify-between rounded-lg bg-[#F1F2F666] px-4 py-3">
                                                    <div className="flex items-center gap-2">
                                                        <div className="h-2 w-2 rounded-full bg-primaryBlue"></div>
                                                        <span className="text-sm font-semibold tracking-wide text-[#343C6A]">
                                                            {t("Added Products")}
                                                        </span>
                                                    </div>
                                                    <span>{groupOrderLines.length}</span>
                                                </div>

                                                {/* Product list from selected groups */}
                                                <div className="space-y-2">
                                                    {groupOrderLines.length === 0 ? (
                                                        <div className="flex h-32 items-center justify-center text-sm text-gray-400">
                                                            {t("No products yet. Select a product group above.")}
                                                        </div>
                                                    ) : (
                                                        groupOrderLines.map((line, index) => (
                                                            <div key={getLineId(line) ?? index}
                                                                style={{
                                                                    backgroundColor: validationState[index] ? "#ffffff" : "#fef2f2",
                                                                    border: validationState[index] ? "1px solid #e5e7eb" : "1px solid #f87171"
                                                                }}
                                                                className="flex justify-between items-center rounded-lg p-2 shadow-sm"
                                                            >
                                                                <img
                                                                    src={line.image_url || line.product_image_url || dummy_image}
                                                                    alt={line.name || line.product_name}
                                                                    className="w-10 h-10 object-contain rounded flex-shrink-0"
                                                                />
                                                                <div className="flex flex-col flex-1 mx-2">
                                                                    <p className="font-semibold text-[12px] leading-tight">
                                                                        {line.name || line.product_name}
                                                                    </p>
                                                                    <p className="text-xs text-gray-600">{line.barcode}</p>
                                                                </div>
                                                                <p className="font-normal whitespace-nowrap text-right mr-3 text-[12px]">
                                                                    EGP {line.sale_price ? line.sale_price.toFixed(2) : line.current_price}
                                                                </p>
                                                                {!userData?.is_sub_store && !userData?.is_warehouse && (
                                                                    <img
                                                                        src={deleteicon}
                                                                        className="cursor-pointer h-4 w-4 mx-2"
                                                                        alt="Delete"
                                                                        onClick={() => handleDeleteLine(getLineId(line))}
                                                                    />
                                                                )}
                                                            </div>
                                                        ))
                                                    )}
                                                </div>
                                            </>
                                        )}
                                    </>
                                )}
                            </div>{/* end scrollable body */}
                        </div>
                    </div>
                )}

                <Modal
                    open={showConfirmModal}
                    onCancel={() => setShowConfirmModal(false)}
                    footer={null}
                    centered
                    closable={false}
                >
                    <div className="text-center p-6">
                        <h3 className="text-lg font-semibold mb-4 text-gray-800">
                            {t("Are you sure you want to delete this promotion ?")}
                        </h3>
                        <div className="flex justify-center gap-4 mt-6">
                            <button
                                onClick={() => setShowConfirmModal(false)}
                                className="px-6 py-2 rounded-lg border border-gray-300 hover:bg-gray-100 text-gray-700 font-semibold"
                            >
                                {t("No")}
                            </button>
                            <button
                                onClick={() => handleDeletePromotion(selectedPromotion)}
                                disabled={loading}
                                className="px-6 py-2 rounded-lg bg-[#FF1616] hover:bg-[#e01414] text-white font-semibold"
                            >
                                {loading ? t("Removing...") : t("Yes")}
                            </button>
                        </div>
                    </div>
                </Modal>

            </div>
        </>
    )
}
export default Promotions;